// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1sZ1u","noInteraction":"EventWrapper_noInteraction__1xK3I"};